import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditConvertNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEditConvertNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEditConvertNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description: 'Location of fetch data',
            default: 'default'
        },
       convert_type: {
            title: 'Convert Type',
           type: 'string',
           enum: [
               'XML to JSON',
               'JSON to XML',
               'Comma Separated Values to Array',
               'Array to Comma Separated Values',
               'Data Model to JSON',
               'JSON to Data Model',
               'JSON to Key/Value Array',
               'Key/Value Array to JSON',
           ],
           default: 'XML to JSON'
       },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to store results',
            default: 'default'
        },
        add_output_to_message: {
            title: 'Add Output To Messages',
            type: 'boolean',
            default: false,
            description: 'Store output as a message to keep in the message history as well as Data store',
        },
    },
    allOf: [
        // {
        //     if: {
        //         properties: {
        //             convert_type: {
        //                 const: 'XML to JSON'
        //             }
        //         }
        //     },
        //     then: {
        //         properties: {
        //             root_tag: {
        //                 title: 'Custom Root Tag',
        //                 type: 'string'
        //             },
        //             lowercase_tags: {
        //                 title: 'Lowercase Tags',
        //                 type: 'boolean',
        //                 default: false,
        //                 description: 'Set all tag values to lowercase'
        //             },
        //             force_array: {
        //                 title: 'Create Array For One',
        //                 type: 'boolean',
        //                 default: true,
        //                 description: 'If only one result, create an array. If more than one result, array is created by default'
        //             },
        //             trim_whitespace: {
        //                 title: 'Trim Whitespace',
        //                 type: 'boolean',
        //                 default: true,
        //             }
        //         }
        //     }
        // },
        {
            if : {
                properties: {
                    convert_type: {
                        const: 'JSON to XML'
                    }
                }
            },
           then: {
               properties: {
                   root_tag: {
                       title: 'Custom Root Tag',
                       type: 'string'
                   },
                   skip_header: {
                       title: 'Exclude XML Header',
                       type: 'boolean',
                       default: false
                   },
                   include_attr_types: {
                       title: 'Include Attribute Types',
                       type: 'boolean',
                       default: false
                   }
               }
           }
        },
        {
            if: {
                properties: {
                    convert_type: {
                        const: 'JSON to Data Model'
                    }
                }
            },
            then: {
                properties: {
                    data_model_structure: {
                        title: 'Data Model Structure',
                        type: 'string',
                        description: 'Data Model Structure to use for conversion',
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    data_management: {
                        const: 'messages'
                    }
                }
            },
            then: {
                properties: {
                    add_output_to_message: {
                        readOnly: true,
                    }
                }
            }
        }
    ]
}

export const nodeDescription: string = "This node is used to convert one data type to another. \n" +
    "The Data Input value will be loaded and processed to convert to the desired format.\n" +
    "Once the conversion has completed, it will be assigned to the Data Store slot for the next node to use.";

